var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items && _vm.items.length)?_c('div',{staticClass:"scale-with-screen"},[_c('div',{staticClass:"highlights"},_vm._l((_vm.items),function(item,i){return _c('highlight',{key:'highlight'+i,attrs:{"item":item}})}),1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }